/**
 * Admin: the administrator-only area of the Security Controls tree (2026-10-12,
 * chore/security-path-reorg). Holds the Nova-only administration paths that used to sit at the
 * root (`CLI`, `Report Views`) or under their own folders (`Support\Document Generation`,
 * `System\Administration`, `Admin\Reports`). None of them has a legacy equivalent, so moving them
 * strands no migrated grant; `sd_SecurityEntry_00_PathMoves.sql` carries existing rows across.
 *
 * `CLI` (with its `Reports\SyncMenu` and `Administration` children) lives in `./cli`, and
 * `Report Views` in `./report-views`; both attach below this folder.
 */

import { folder } from '../builder';

export const admin = folder('Admin');
export const documentGeneration = admin.tool('Document Generation');
export const documentGenerationOperate = documentGeneration.command('Operate');
export const documentGenerationView = documentGeneration.command('View');
